import { IconProps } from "@/types/icons";

export const Meta = ({
  className,
  height = 20,
  width = 20,
  decorative = false,
  ariaLabel = "Meta",
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 8 16"
      fill="none"
      className={className}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.19741 8.64433H7.54644L7.89633 5.81939H5.20259V4.01937C5.20259 3.19624 5.40216 2.63357 6.54946 2.63357H8V0.116192C7.29676 0.0610801 6.59698 0.00952361 5.89633 0.00952361C4.06998 -0.130034 2.48035 1.28065 2.34471 3.1598C2.33175 3.3438 2.33261 3.52869 2.34816 3.7118V5.81939H0V8.64433H2.34903V16H5.19741V8.64433Z"
        fill="currentColor"
      />
    </svg>
  );
};
